export const fao56En = {
  fao56: {
    pageTitle: "FAO-56 Methodology & Internal Coherence Validation",
    pageSubtitle: "FAO-56 Penman-Monteith implementation with internal algorithmic-coherence validation against a reference weather service. Not peer-reviewed. Not externally certified.",
    implementation: "FAO-56 Implementation",
    validationOngoing: "Implementation operational — internal validation only",
    rSquaredMadrid: "R² (algorithmic coherence)",
    bestStation: "vs reference weather service (Open-Meteo)",
    rmseMadrid: "RMSE (mm/day)",
    belowFaoTarget: "Internal coherence vs reference, not vs ground-truth",
    totalDataPoints: "Observations (n)",
    stationsPerDays: "4 locations · period 2025-11 to 2026-03",
    validationNote: "This is an internal coherence check between the Sentinel Crop implementation and a reference weather service (Open-Meteo). It is NOT a validation against ground-truth lysimeters or surface stations. No peer review, no third-party audit and no FAO endorsement exist.",
    downloadReport: "Download Implementation Report (PDF)",
    methodology: "FAO-56 Penman-Monteith Methodology",
    methodologyDesc: "The FAO-56 Penman-Monteith equation is the international standard for calculating reference evapotranspiration (ET₀), recommended by the Food and Agriculture Organization of the United Nations.",
    formula: "Formula:",
    inputVariables: "Input Variables:",
    netRadiation: "Net radiation at crop surface (MJ/m²/day)",
    soilHeatFlux: "Soil heat flux (MJ/m²/day) - assumed 0 for daily",
    meanAirTemp: "Mean air temperature at 2m (°C)",
    windSpeed: "Wind speed at 2m height (m/s)",
    vapourPressure: "Vapour pressure deficit (kPa)",
    slopeVapour: "Slope of vapour pressure curve (kPa/°C)",
    psychrometric: "Psychrometric constant (kPa/°C)",
    methodHierarchy: "Calculation Method Hierarchy",
    methodHierarchyDesc: "Sentinel Crop implements a quality-first approach with automatic fallback methods when complete data is unavailable:",
    fao56Preferred: "FAO-56 Penman-Monteith (Preferred)",
    fao56PreferredDesc: "Complete implementation requiring temperature, humidity, wind speed, and solar radiation. Provides highest accuracy and is the international standard.",
    qualityExcellent: "Quality: Excellent",
    hargreaves: "Hargreaves-Samani (Fallback)",
    hargreavesDesc: "Simplified method requiring only temperature data and extraterrestrial radiation. Used when complete meteorological data is unavailable.",
    qualityGood: "Quality: Good",
    tempBased: "Temperature-Based Approximation (Last Resort)",
    tempBasedDesc: "Basic estimation used only when no other data is available. Provides rough approximation with clear quality warnings.",
    qualityLimited: "Quality: Limited",
    dataSources: "Data Sources & Integration",
    nasaPower: "NASA POWER API",
    nasaPowerDesc: "Primary meteorological data source providing global coverage with 0.5° × 0.5° spatial resolution.",
    dailyTemp: "Daily temperature (max/min)",
    relativeHumidity: "Relative humidity",
    windSpeed2m: "Wind speed at 2m height",
    solarRadiation: "Solar radiation",
    historicalData: "Historical data since 1981",
    aemetValidation: "Reference Weather Service Coherence Check",
    aemetValidationDesc: "We compare our FAO-56 ET₀ output against the ET₀ value returned by a reference weather service (Open-Meteo). This checks algorithmic coherence, NOT ground-truth accuracy.",
    currentValidation: "Current coverage: 4 Spanish locations (Madrid, Barcelona, Seville, Valencia)",
    dataPointsCollected: "n = 472 daily observations (period 2025-11-24 to 2026-03-21)",
    expansionPlanned: "Ground-truth validation against lysimeters / surface stations: not yet performed",
    highPrecision: "Modeled reference values, not field measurements",
    realTimeQC: "Internal quality control",
    continuousValidation: "Used for internal coherence monitoring",
    validationStatus: "Validation Status — Honest Disclosure",
    phase1: "Phase 1: Internal coherence check vs reference weather service ✅",
    phase2: "Phase 2: Ground-truth validation (lysimeters / surface stations) — not started",
    phase3: "Phase 3: Independent peer review — not started",
    phase4: "Phase 4: External third-party audit — not started",
    systemPerformance: "System Performance (October 2025)",
    responseTimes: "Response Times",
    avgResponse: "Average Response",
    p95Latency: "P95 Latency",
    cacheHitRatio: "Cache Hit Ratio",
    uptime: "Uptime",
    dataQuality: "Data Quality",
    fao56Coverage: "FAO-56 Coverage",
    nasaPowerAvailability: "NASA POWER Availability",
    dataCompleteness: "Data Completeness",
    qualityIndicators: "Quality Indicators",
    transparent: "Transparent",
    scientificReferences: "Scientific References",
    transparencyCommitment: "Transparency and Honesty Commitment",
    transparencyDesc: "All calculations, formulas, input data sources and quality indicators are completely transparent and traceable. Each ET₀ calculation includes metadata about the method used, data quality and scientific references.",
    currentValidationStatus: "Current Validation Status",
    currentValidationStatusDesc: "What we have today: an internal algorithmic-coherence check (R²=0.94, RMSE=0.33 mm/day, n=472) between our FAO-56 implementation and a reference weather service. What we do NOT have: ground-truth validation against lysimeters or surface stations, peer-reviewed publication, third-party audit or any certification (FAO, AEMET, AEF, ISO 27001, SOC 2, university). We disclose this openly so users can decide based on facts, not marketing."
  }
};